import { render, staticRenderFns } from "./me.vue?vue&type=template&id=f1883ec8&"
import script from "./me.ts?vue&type=script&lang=js&"
export * from "./me.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports